import SurveysShow from './SurveysShow'
export {SurveysShow}
export default SurveysShow
